import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, LineChart, Line } from "recharts";

const FUNNEL_ORDER = ["step_2", "step_3", "step_4", "step_5", "step_6", "step_7", "step_8", "step_9"];
const FUNNEL_LABELS = {
  step_2: "Category", step_3: "Concern", step_4: "Profile", step_5: "Routine",
  step_6: "Delivery", step_7: "Payment", step_8: "Review", step_9: "Submitted",
};

export default function AdminAnalytics() {
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/admin/analytics").then((r) => setData(r.data)); }, []);

  if (!data) return <div className="p-12">Loading…</div>;

  const funnel = FUNNEL_ORDER.map((k) => ({ name: FUNNEL_LABELS[k], visits: data.funnel_steps[k] || 0 }));
  const perRep = (data.per_rep || []).map((r) => ({ name: `${r.rep_code}`, count: r.count }));
  const perLang = (data.per_language || []).map((r) => ({ name: r.language, count: r.count }));

  return (
    <div className="p-8 lg:p-12 max-w-6xl">
      <p className="overline">Performance</p>
      <h1 className="editorial-h text-5xl text-brand-dark mt-2">Analytics</h1>

      <div className="grid sm:grid-cols-3 gap-4 mt-8">
        <div className="bg-white border border-brand-line p-6">
          <p className="overline">Total Leads</p>
          <p className="font-serif text-5xl mt-2">{data.total_leads}</p>
        </div>
        <div className="bg-white border border-brand-line p-6">
          <p className="overline">WA opened</p>
          <p className="font-serif text-5xl mt-2">{data.wa_opened}</p>
          <p className="text-xs text-brand-muted mt-1">
            {data.total_leads ? Math.round((data.wa_opened / data.total_leads) * 100) : 0}% of leads
          </p>
        </div>
        <div className="bg-white border border-brand-line p-6">
          <p className="overline">Last 7 days</p>
          <p className="font-serif text-5xl mt-2">{data.last_7_days}</p>
        </div>
      </div>

      <div className="bg-white border border-brand-line p-6 mt-8">
        <p className="overline mb-4">Funnel drop-off</p>
        <div style={{ width: "100%", height: 280 }}>
          <ResponsiveContainer>
            <LineChart data={funnel}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E5DCD3" />
              <XAxis dataKey="name" stroke="#5C544F" style={{ fontSize: 12 }} />
              <YAxis stroke="#5C544F" style={{ fontSize: 12 }} />
              <Tooltip contentStyle={{ background: "#fff", border: "1px solid #E5DCD3", borderRadius: 0 }} />
              <Line type="monotone" dataKey="visits" stroke="#A31D1D" strokeWidth={2} dot={{ fill: "#A31D1D" }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-6 mt-6">
        <div className="bg-white border border-brand-line p-6">
          <p className="overline mb-4">Leads per rep</p>
          <div style={{ width: "100%", height: 260 }}>
            <ResponsiveContainer>
              <BarChart data={perRep}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E5DCD3" />
                <XAxis dataKey="name" stroke="#5C544F" style={{ fontSize: 11 }} />
                <YAxis stroke="#5C544F" style={{ fontSize: 12 }} />
                <Tooltip contentStyle={{ background: "#fff", border: "1px solid #E5DCD3", borderRadius: 0 }} />
                <Bar dataKey="count" fill="#A31D1D" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="bg-white border border-brand-line p-6">
          <p className="overline mb-4">Leads per language</p>
          <div style={{ width: "100%", height: 260 }}>
            <ResponsiveContainer>
              <BarChart data={perLang}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E5DCD3" />
                <XAxis dataKey="name" stroke="#5C544F" style={{ fontSize: 12 }} />
                <YAxis stroke="#5C544F" style={{ fontSize: 12 }} />
                <Tooltip contentStyle={{ background: "#fff", border: "1px solid #E5DCD3", borderRadius: 0 }} />
                <Bar dataKey="count" fill="#2A2421" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}
